import React, { useState, useEffect } from 'react';
import { Provider } from 'react-redux';
import FixtureBar from '../components/FixtureBar';
import PropTypes from 'prop-types';
import { useWindowSize } from 'common/react/hooks/use-window-resize';

/**
 * A Provider is used to wrap the "entry point" component for a React widget with a Redux Provider,
 * which is used to provide access to the Redux store.
 *
 * The "data" prop will contain any "data-" attributes added to the DOM element that the React widget will be rendered into.
 *
 * The Provider can also contain any "react-router" logic that may be required by a component.
 */

const FixtureBarProvider = ({ store, data }) => {
    const windowSize = useWindowSize();
    // Desktop-only unless the editor ticks "Show on mobile" on the widget
    // (data-show-on-mobile). `data` is the container's dataset, so the value is
    // the string 'false' when unchecked — existing instances keep rendering at
    // >= PULSE.app.measurements.desktop only.
    const showOnMobile = data.showOnMobile === 'true';
    const shouldShow = () =>
        showOnMobile || windowSize.width >= PULSE.app.measurements.desktop;
    const [showFixtureBar, setShowFixtureBar] = useState(shouldShow());

    useEffect(() => {
        setShowFixtureBar(shouldShow());
    }, [windowSize.width]);

    return (
        <Provider store={store}>
            {showFixtureBar && <FixtureBar data={data} />}
        </Provider>
    );
};

FixtureBarProvider.propTypes = {
    store: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired
};

export default FixtureBarProvider;
